module.exports = __webpack_public_path__ + "static/media/sg6cr168.88934b72.png";